<template>
  <div :class="$style.container">
    <svg width="20" height="8" viewBox="0 0 20 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C13 0 15.9999 8 20 8H0C3.9749 8 7 0 10 0Z" fill="white" />
    </svg>
    {{ message }}
  </div>
</template>

<script>
export default {
  name: 'ReportTooltip',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="sass" module>
  .container
    position: relative
    font-weight: 500
    font-size: 12px
    line-height: 15px
    color: #212121
    background-color: #fff
    padding: 10px
    border-radius: 5px
    z-index: 1000

    svg
      width: 20px
      height: 8px
      position: absolute
      top: -8px
      left: 14px
</style>
